import React from 'react';

import { Tooltip } from 'react-tooltip';
import {
  CommunityCardContainer,
  Link,
  Image,
  SponsorImage,
  DetailsContainer,
  CardName,
  Rating,
  NameAndRatingContainer,
  TagsContainer,
  Tag,
  Icon,
  CompletionContainer,
} from './styles';

export default function CommunityCard({
  _id,
  pageType,
  name,
  image,
  thumbnail,
  averageRating,
  tags,
  link,
  totalCompletions,
  sponsor,
  contestLogo,
  isCompletedByUser,
}) {
  return (
    <CommunityCardContainer isCourse={pageType === 'courses'}>
      <Link to={link}>
        <Image image={image || thumbnail} />
        {sponsor && contestLogo && <SponsorImage data-tip="Sponsor" src={contestLogo} />}
        <DetailsContainer>
          <NameAndRatingContainer>
            <CardName>{name}</CardName>
            {pageType !== 'courses' && (
              <Rating>
                {Math.round(averageRating * 10) / 10} <Icon className="fa-solid fa-star" />
              </Rating>
            )}
          </NameAndRatingContainer>
          <TagsContainer isEmptyTag={tags.length === 0}>
            {tags.map((tag) => (
              <Tag key={tag} isDifficultyTag={['Easy', 'Medium', 'Hard'].includes(tag)}>
                {tag}
              </Tag>
            ))}
          </TagsContainer>
          {pageType !== 'courses' && (
            <CompletionContainer>
              <Tooltip id={`completedTipFor${_id}`} place="left" className="custom-tooltip" />
              {isCompletedByUser && (
                <Icon
                  className="fa-solid fa-circle-check"
                  checkMarkIcon
                  aria-hidden="true"
                  data-tooltip-id={`completedTipFor${_id}`}
                  data-tooltip-content="Completed"
                  data-tooltip-variant="info"
                />
              )}{' '}
              {totalCompletions > 0 && <>No. of completions: {totalCompletions ?? 0}</>}
            </CompletionContainer>
          )}
        </DetailsContainer>
      </Link>
    </CommunityCardContainer>
  );
}
